<template>
  <div :style="loaderStyle">
    <SfLoader
      class="spinner-loader"
    />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'SpinnerLoader',

  props: {
    size: {
      type: String,
      default: '',
    },
  },
  setup(props) {

    const loaderStyle = computed(() =>
      props.size && `height: ${props.size}; width: ${props.size};`,
    );

    return {
      loaderStyle,
    };
  
  },
});

</script>

<style scoped lang="scss">
.spinner-loader {
  :deep(.sf-loader__overlay) {
    background: unset;
  }
}
</style>
